import { h } from 'vue';

export default {
    // functional: true,

    props:
    {
        label:
        {
            type: String,
            default: null,
        },

        divClass:
        {
            type: String,
            default: null
        }
    },

    render()
    {
        return h(
            'div',
            {
                class: this.divClass,
            },
            [
                h(
                    'small',
                    {
                        class: 'vh-text-bold vh-text-danger'
                    },
                    [
                        h(
                            'i',
                            {
                                class: 'ti ti-info-alt vh-margin-xsmall-right'
                            }
                        )
                    ],

                    this.label
                ),
            ]
        );
    },
};
